// Подписи экрана бэкапов: размер файла, состояние S3.

import { DASH, NBSP, formatNumber } from '@/lib/format'

import type { BackupRun } from './api'

const UNITS = ['Б', 'КБ', 'МБ', 'ГБ'] as const

/** 340 → «340 Б», 1536 → «1,5 КБ», 12 345 678 → «11,8 МБ». */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined || !Number.isFinite(bytes) || bytes < 0) return DASH
  let value = bytes
  let unit = 0
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024
    unit += 1
  }
  return `${formatNumber(value, { digits: unit === 0 ? 0 : 1 })}${NBSP}${UNITS[unit]}`
}

export type S3State = { tone: 'neutral' | 'accent' | 'danger'; text: string }

export function s3State(configured: boolean, last: BackupRun | null): S3State {
  if (!configured) return { tone: 'neutral', text: 'S3 не настроен' }
  if (!last || last.s3_ok === null) return { tone: 'neutral', text: 'S3 настроен, копий ещё не было' }
  return last.s3_ok ? { tone: 'accent', text: 'копия в S3 загружена' } : { tone: 'danger', text: 'ошибка выгрузки в S3' }
}

export function runStatusText(run: BackupRun): string {
  if (!run.local_ok) return 'не удался'
  if (run.s3_ok === false) return 'локально ок, S3 — ошибка'
  if (run.s3_ok) return 'ок, есть копия в S3'
  return 'ок'
}
